const Director = 'Director'
const Analyst = 'Analyst'
const CreditAnalyst = 'CreditAnalyst'
const SalesExecutive = 'SalesExecutive'

export default [
  {
    path: '/whatsapp_messages',
    name: 'WhatsappMessages',
    meta: {
      auth: true,
      roles: [Director, Analyst, CreditAnalyst, SalesExecutive],
    },
    component: () => import('@/_backoffice/_registrations/pages/WhatsappMessages.vue'),
  },
]
